import { defineMessages } from 'react-intl';

export default defineMessages({
    addStudentConfirmation: {
        id: 'app.components.studentRoll.addStudentConfirmation',
        defaultMessage: 'Student added'
    },
    yearGroupList: {
        id: 'app.components.studentRoll.yearGroupList',
        defaultMessage: 'Year'
    },
    firstName: {
        id: 'app.components.studentRoll.firstName',
        defaultMessage: 'FIRST NAME'
    },
    surname: {
        id: 'app.components.studentRoll.surname',
        defaultMessage: 'SURNAME'
    },
    year: {
        id: 'app.components.studentRoll.year',
        defaultMessage: 'YEAR'
    },
    username: {
        id: 'app.components.studentRoll.username',
        defaultMessage: 'USERNAME'
    },
    password: {
        id: 'app.components.studentRoll.password',
        defaultMessage: 'PASSWORD'
    },
    classes: {
        id: 'app.components.studentRoll.classes',
        defaultMessage: 'CLASSES'
    },
    groups: {
        id: 'app.components.studentRoll.groups',
        defaultMessage: 'GROUPS'
    },
    teachers: {
        id: 'app.components.studentRoll.teachers',
        defaultMessage: 'TEACHERS'
    },
    edit: {
        id: 'app.components.studentRoll.edit',
        defaultMessage: 'EDIT'
    },
    noStudentsAvailable: {
        id: 'app.components.studentRoll.noStudentsAvailable',
        defaultMessage: 'No students available'
    },
    allSurnames: {
        id: 'app.components.studentRoll.allSurnames',
        defaultMessage: 'All surnames'
    },
    allYears: {
        id: 'app.components.studentRoll.allYears',
        defaultMessage: 'All years'
    },
    allClasses: {
        id: 'app.components.studentRoll.allClasses',
        defaultMessage: 'All classes'
    },
    unassignedStudents: {
        id: 'app.components.studentRoll.unassignedStudents',
        defaultMessage: 'Unassigned students'
    },
    assignedStudents: {
        id: 'app.components.studentRoll.assignedStudents',
        defaultMessage: 'Assigned students'
    }
});



// WEBPACK FOOTER //
// ./app/components/student-roll/messages.js